<template>
    <div class="tsa-myDraft">
        <div class="top">
            <div class="breadcrumb">
                <span class="title">作品草稿箱</span>
                <span class="search" :class="{'open' : filterShow}" @click="filterShow=!filterShow">
                    {{filterShow ?'收起' : '更多查询'}}
                    <van-icon class="arrrow" name="arrow-down" />
                    <b v-if="filterNum>0">{{ filterNum }}</b>
                </span>
            </div>
            <div class="filter" v-show="filterShow">
                <el-row :gutter="10">
                    <el-col :span="14">
                        <TsaConditionSearchV21 v-model="condition.nameOrDescription" placeholder="请输入作品名称或描述"></TsaConditionSearchV21>
                    </el-col>
                    <el-col :span="10">
                        <TsaConditionSearchV21 v-model="condition.owner" placeholder="请输入权利人"></TsaConditionSearchV21>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <TsaConditionSelectV2 v-model="condition.category" placeholder="作品类型" :options="categorysList" />
                    </el-col>
                    <el-col :span="12">
                        <TsaConditionSelectV2 v-model="condition.applyUserId" placeholder="申请账号" :options="accountList" />
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12"><span>&nbsp;</span></el-col>
                    <el-col :span="12">
                        <div class="btn-group">
                            <div class="btn">
                                <TsaButton plain @click="resetFilter" size="smaller">重置</TsaButton>
                            </div>
                            <div class="btn">
                                <TsaButton @click="serarch" size="smaller" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">搜索</TsaButton>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        
        <div class="scroll-area">
            <TsaPullToRefresh
                ref="TsaPullToRefresh"
                @on-refresh="refresh"
                @on-load="load"
                @on-scroll="scroll"
            >
                <div class="item" v-for="(item, index) in list" :key="index" @click="gotoDetail(item)">
                    <div class="icon">
                        <img src="../../../assets/images/draft-icon.png" alt="">
                    </div>
                    <div class="info">
                        <h4>{{ item.name }}</h4>
                        <p>
                            <span class="type">{{ item.category | mapFilter(categorysList) }}</span>
                            <span class="line"> | </span>
                            <span class="time">{{ item.updatedAt | timeFormat('YYYY-MM-DD HH:mm:ss')}}</span>
                        </p>
                    </div>
                    <div class="more">
                        <el-dropdown trigger="click" placement="bottom" ref="myDropdown" @command="command($event, item)">
                            <span class="el-icon-more" @click.stop></span>
                            <el-dropdown-menu slot="dropdown" class="tsa-custom-dropdown-menu">
                                <el-dropdown-item command="gotoDetail">继续认证</el-dropdown-item>
                                <el-dropdown-item command="deleteFun">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        
                    </div>
                </div>
            </TsaPullToRefresh>
        </div>
    </div>
</template>

<script>
import commonMixins from '@/mixins/common'
import myDraftMixins from '@/mixins/myDraft'
export default {
    mixins: [ myDraftMixins,commonMixins ],
    data () {
        return {
            filterShow:true,
        }
    },
    computed:{
        filterNum(){
            let fileds=['applyUserId','nameOrDescription','owner','category']
            let array=[];
            Object.keys(this.condition).map(key => {
                if (this.condition[key] && this.condition[key] !== null && fileds.includes(key)) {
                    array.push(this.condition[key])
                }
            })
            if (array.length > 0) {
                return array.length
            } else {
                return 0
            }
        }
    },
    mounted () {
        this.getAccountList()
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>
    .tsa-myDraft {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #F2F2F7;
        box-sizing: border-box;
        * {
            box-sizing: border-box;
        }
        .top{
            padding: 12px;
            padding-bottom: 0;
            .breadcrumb{
                display: flex;
                justify-content: space-between;
                padding: 0 4px;
                margin-bottom: 10px;
                span{
                    font-size: 14px;
                    color: #333;
                    &.title{
                        font-weight: bold;
                    }
                    &.search{
                        font-size: 12px;
                        position: relative;
                        b{
                            display: flex;
                            position: absolute;
                            width: 14px;
                            height: 14px;
                            font-size: 12px;
                            background: #005CE6;
                            color: #fff;
                            border-radius: 50%;
                            align-items: center;
                            justify-content: center;
                            right: -10px;
                            top: -8px;
                        }
                        &.open{
                            .arrrow{
                                transform: rotate(180deg);
                            }
                        }
                    }
                }
            }
            .filter{
                .el-row{
                    margin: 10px 0;
                    .el-col{
                        font-size: 14px;
                    }
                }
                .btn-group {
                    display: flex;
                    justify-content: flex-end;
                    .btn {
                        width: 62px;
                        margin-left: 8px;
                        .tsa-button{
                            box-sizing: border-box;
                        }
                    }
                }
            }
        }
        .scroll-area{
            display: flex;
            flex: 1;
            overflow: hidden;
            .tsa-pullToRefresh {
                padding: 0 12px;
            }
        }

        .item {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 16px;
            border-radius: 8px;
            margin-top: 8px;
            background: #FFFFFF;
            &:first-child {
                margin-top: 0;
            }
            .icon {
                width: 48px;
                height: 48px;
                margin-right: 12px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .info {
                flex: 1;
                margin-right: 10px;
                overflow: hidden;
                h4 {
                    font-weight: bold;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    margin-bottom: 4px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                p {
                    font-size: 10px;
                    line-height: 18px;
                    .type {
                        color: #FF9318;
                    }
                    .line {
                        color: #999999;
                    }
                    .time {
                        color: #999999;
                    }
                }
            }
            .more {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                    font-size: 16px;
                    color: #000000;
                }
            }
        }
    }
</style>